import React from 'react';
import { QuoteIcon } from 'lucide-react';
const useCases = [{
  id: 'lead-gen',
  title: 'B2B lead generation',
  description: 'Use our local business API to extract targeted local business lists with direct emails and phone numbers for your sales team.',
  quote: 'We pull 10k fresh leads daily, cutting acquisition cost in half.',
  author: 'Sarah J., VP of sales'
}, {
  id: 'data-enrichment',
  title: 'Data enrichment',
  description: 'Our local business data API returns 50+ data points per local business — pass a name, get back revenue, employees, tech stack, and more.',
  quote: 'We enriched our entire Salesforce instance over the weekend.',
  author: 'Amanda W., RevOps manager'
}, {
  id: 'market-research',
  title: 'Market research',
  description: 'Use our local business search API to analyze local markets at scale — local business density, categories, and competitor presence.',
  quote: 'We map competitor density across entire states in minutes.',
  author: 'David C., data analyst'
}];
export function UseCases() {
  return <section className="py-24 bg-white" data-id="element-6290">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6291">
        <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-6292">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-6293">
            The <span className="text-blue-600" data-id="element-6294">local business API</span> for
            every use case
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-6295">
            Whether you're building a SaaS product, enriching your CRM, or
            conducting market research — our API provides the foundation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6296">
          {useCases.map(useCase => <div key={useCase.id} className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-6297">
              <div data-id="element-6298">
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-6299">
                  {useCase.title}
                </h3>
                <p className="text-base text-slate-600 leading-relaxed" data-id="element-6300">
                  {useCase.description}
                </p>
              </div>
              <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-6301">
                <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-6302" />
                <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-6303">
                  {useCase.quote}
                </p>
                <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-6304">
                  — {useCase.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}